import { z } from 'zod';

/**
 * An on premise location, usually a caravan park or marina.
 */
export const locationSchema = z.object({
  name: z.string(),
  address: z.string().nullable().default(null),
  code: z.string(),
  companyId: z.string(),
  apiBaseUrl: z.string(),
  /**
   * `apiUsername` is always "apiuser"
   */
  apiPassword: z.string(),

  /**
   * The park/marina office email address.
   * Notifications of when a new site is active or checked out will be sent here.
   */
  email: z.string().nullable().default(null),

  /**
   * A snapshot of the unit prices is copied to new sessions.
   * All calculations use `session.electricityUnitPrice` and `session.waterUnitPrice`,
   * so changing these values here only affects future sessions.
   */
  electricityUnitPrice: z.number().default(0),
  waterUnitPrice: z.number().default(0),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
  updatedAt: z.number().optional(),
});
export type Location = z.output<typeof locationSchema>;

export const locationStrictSchema = locationSchema.safeExtend({
  name: z.string().trim().min(1),
  code: z.string().trim().length(3),
  apiBaseUrl: z.httpUrl(), // http or https URLs only
});

export const locationCvxSchema = locationSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
  updatedAt: z.number(),
});
export type LocationCvx = z.output<typeof locationCvxSchema>;
